import { ThumbnailsViewIcon } from '@carboncopyco/icons';
import type { MouseEventHandler } from 'react';
import { SidebarButton } from './SidebarButton';

export interface AllWorkspacesButtonProps {
  isSelected: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const AllWorkspacesButton = ({
  isSelected,
  onClick,
}: AllWorkspacesButtonProps) => {
  return (
    <SidebarButton
      isSelected={isSelected}
      onClick={onClick}
      tooltipText="All Workspaces"
      aria-label="All Workspaces"
    >
      <ThumbnailsViewIcon size={20} />
    </SidebarButton>
  );
};
